<template>
<v-card
    class="elevation-0" width="89vw"
    :max-width="$vuetify.breakpoint.mdAndUp ? '450px' : '100%'"
>
    <v-card-text class="px-6" :class="{ 'pt-10 pb-6': !showInfo }">
        <v-row>
            <v-col v-if="!showInfo">
                <template v-if="fee">
                    <v-img
                        src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/work-done.jpg"
                        class="mx-auto illustration mb-3 mt-n5"
                    />

                    <v-img
                        src="/images/success.gif"
                        class="success-gif mx-auto"
                    />
                </template>
                <template v-else>
                    <v-img
                        src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/working.gif"
                        class="mx-auto illustration mb-3 mt-10"
                    />

                    <p class="subtitle-1 text-center mb-0 font-weight-bold">
                        Negotiating the best fee for you...
                    </p>

                    <div class="text-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            class="ml-2"
                        />
                    </div>
                </template>
            </v-col>
            <template v-else>
                <v-col class="text-center">
                    <h3 class="font-weight-bold title">
                        Something you should know
                    </h3>

                    <v-img
                        src="https://s3.amazonaws.com/files.kaoshinetwork.com/illustrations/pay-attention.jpg"
                        class="mx-auto my-3"
                        height="150"
                        max-width="150"
                    />

                    <p class="mb-0">
                        If you bank with Wells Fargo, your account is restricted to amounts
                        <span class="font-weight-bold">$500 or lower</span>
                        for transfers to a first time zelle recipient, per day.
                        It gets increased after the third transfer to the same recipient
                    </p>
                </v-col>
                <v-col cols="12" class="py-0">
                    <v-checkbox
                        class="mt-0"
                        style="height: 22px;"
                        v-model="hideInformationWarning"
                        label="Don't show this again."
                    ></v-checkbox>
                </v-col>
            </template>
        </v-row>
        <v-row v-if="fee && !showInfo">
            <v-col>
                <h3 class="text-center">Your fee is: {{ feeInMatcherCurrency.toFixed(2) }} {{ currencyCode }}</h3>
            </v-col>
        </v-row>
    </v-card-text>
    <v-card-actions class="pa-6">
        <v-btn
            class="text-capitalize px-6 rounded-lg"
            :class="[{ 'mx-auto': !fee }]"
            text
            color="red darken-2"
            large
            @click="$emit('close')"
        >
            {{ showInfo ? 'Try a lower amount' : 'Cancel' }}
        </v-btn>
        <template v-if="fee">
            <v-spacer />
            <v-btn
                v-if="!showInfo && !hideInformationWarning && showWarning"
                class="text-capitalize px-10 rounded-lg"
                color="primary"
                dark
                depressed
                large
                @click.native="showInfo = true"
            >
                Proceed
            </v-btn>
            <v-btn
                v-else
                class="text-capitalize px-10 rounded-lg"
                color="primary"
                dark
                depressed
                large
                @click.native="submit"
            >
                Continue
            </v-btn>
        </template>
    </v-card-actions>
</v-card>
</template>

<script>
export default {
    props: {
      orderId: String,
      amount: Number,
      currencyCode: String,
      showWarning: Boolean,
      pbToMatcherExchangeRate: Number,
    },
    data() {
        return {
            loading: false,
            minSpinningTime: 2000,
            requestedAt: null,
            fee: null,
            showInfo: false,
        };
    },
    computed: {
        feeInMatcherCurrency() {
            if (this.fee) {
                return this.fee.fee/(this.pbToMatcherExchangeRate || 1)
            }

            return null
        },
        hideInformationWarning: {
            get() {
                return !this.$store.state.transferInformationWarning;
            },
            set(value) {
                this.$store.dispatch('updateInformationWarning', !value);
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.getRandomMatcherFee();
        }, 3000);
    },
    methods: {
      getRandomMatcherFee() {
          this.loading = true;
          this.requestedAt = performance.now();
          Vue.backendApi().order(this.orderId).getRandomMatcherFee({ amount: this.amount })
              .then((response) => {
                  const { data } = response;
                  // if request took lees than minSpinningTime, add timeout
                  const requestDuration = performance.now() - this.requestedAt;
                  const timeout = requestDuration < this.minSpinningTime ? this.minSpinningTime - requestDuration : 0;
                  setTimeout(() => {
                      this.loading = false;
                      this.fee = data;
                  }, timeout);
              })
              .catch((err) => {
                  this.loading = false;
                  this.$swal({
                      type: 'error',
                      title: 'Error generating random fee',
                      text: err,
                  });
              })
      },
      submit() {
        this.$emit('received', this.fee);
      },
    },
}
</script>

<style scoped>
.success-gif {
  width: 50px;
  height: 50px;
}

.illustration {
    width: 200px;
    height: 175px;
}
</style>
